<pinnakl-modal
  (closeModal)="reject()"
  [hideDialog]="hideConfirmActionDialog"
>
  <div>
    <div class="tw:flex tw:items-center tw:p-4 tw:border-b tw:border-(--p-content-border-color)">
      <div class="tw:text-[0.875rem] tw:font-semibold">Confirm Action</div>
    </div>
    <div class="tw:relative tw:flex-1 tw:p-4">{{ message }}</div>
    <div
      class="tw:flex tw:flex-wrap tw:items-center tw:justify-end tw:gap-2 tw:p-4 tw:border-t tw:border-(--p-content-border-color)"
    >
      <prime-button
        (onClick)="confirm()"
        label="YES"
      ></prime-button>
      <prime-button
        (onClick)="reject()"
        label="NO"
        severity="secondary"
      ></prime-button>
    </div>
  </div>
</pinnakl-modal>
